var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 284,
    height: 218.368,
    viewBox: "0 0 284 218.368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-45.68 -88.862)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(45.68 300.23)",
    fill: "#f7f7f7",
    fontSize: 29.51,
    fontFamily: "SitkaDisplay, Sitka Display"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "MAGIC PHOTOGRAPHY")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25.449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.29,260.71H132.13c-5.62,0-6-.43-6-6V97.27c0-8.3,0-8.33,8.16-8.34h72.38a11,11,0,0,1,4,.29,3.43,3.43,0,0,1,1.85,2.58,3.17,3.17,0,0,1-2.11,2.2,69.442,69.442,0,0,1-8.17.21h-65c-5.3,0-5.4,0-5.4,5.46q-.06,45.19,0,90.38v58.07c0,6.21,0,6.2,6.4,6.2l147.22.09c6.84,0,6.84,0,6.84-7V181.16c0-1.1.05-2.19,0-3.28-.1-2.38.69-4.39,3.32-3.86,1,.21,2.31,2.36,2.39,3.69.31,4.89.18,9.81.18,14.72v62.16c0,6,0,6.12-6.12,6.12Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.55,153.63c-4.68,6.3-9.48,12.53-14,18.93-4.25,6-8.1,12.31-12.44,18.24-1,1.32-3.29,1.65-5,2.43-.47-1.77-1.72-3.78-1.27-5.27,3.87-12.79,8-25.48,12.14-38.19.7-2.17,1.61-4.47,4.45-3.63,3.15.94,2.34,3.56,1.66,5.8a91.888,91.888,0,0,0-3.68,14.81c1.06-1.43,2.07-2.91,3.17-4.3C192,156.91,196.21,151.2,201,146c1.46-1.59,5-2.93,6.61-2.22s2.8,4.13,2.83,6.39c.07,4.84-.72,9.7-.6,14.94,2-3.21,4-6.46,6.08-9.61,7.35-11,14.62-22,22.26-32.76a27.33,27.33,0,0,1,7.9-6.94c4.42-2.75,8.43-.66,8.47,4.59.05,6.23,0,12.66-1.41,18.67-6.13,26-12.74,51.85-19.24,77.75-1.46,5.81-3.12,11.57-4.8,17.33a10.73,10.73,0,0,1-2,4.36,4.17,4.17,0,0,1-3.6.79c-.8-.25-1.63-1.84-1.65-2.86a17.28,17.28,0,0,1,1-4.78c5.41-19.71,11.22-39.31,16.14-59.15,3.7-14.91,6.27-30.1,9.28-45.18a21.8,21.8,0,0,0,0-4.2l-1.09-.54c-2.84,3.34-6.08,6.42-8.45,10.07-9.42,14.5-18.57,29.18-27.82,43.79-1.1,1.73-2.17,3.47-3.29,5.17-1.37,2.08-3.08,4.81-5.67,3.14-1.46-.95-2.27-4.2-2-6.25.8-6.62,2.24-13.16,3.38-19.74.27-1.55.34-3.13.5-4.69Z",
    fill: "#f7f7f7"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFooter);
export default __webpack_public_path__ + "static/media/logo-footer.9b886ef6d38be842d48fe49ad74094c0.svg";
export { ForwardRef as ReactComponent };